<template>
  <textarea-input
      :id="id"
      :value="value"
      :rows="rows"
      :cols="cols"
      :disabled="disabled"
      :required="required"
      v-model="textareaData"
      :class="{'invalid': !isValid}"
      @change="handleChange"
      ref="basetextarearef"
  >
    <slot></slot>
  </textarea-input>
</template>

<script>
export default {
  name: "JSONTextareaInput",
  props: {
    id: String,
    value: [String, Number],
    rows: [String, Number],
    cols: [String, Number],
    disabled: Boolean,
    indentation: {
      type: Number,
      default: 4
    },
    required: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      lastCursorPosition: 0,
      isValid: true,
    }
  },
  computed: {
    textareaData: {
      get(){
        const value = this.getTextAreaJsonValue();
        this.handleChange(value);
        return value;
      },
      set() {
        // declaring setter, but assigning value with onChange method
      }
    }
  },
  methods: {
    handleChange(value){
      this.$emit('input', value)
    },
    getTextAreaJsonValue(){
      try {
        this.lastCursorPosition = this.$refs.basetextarearef.getCursorPosition();
        this.$nextTick(() => {
          this.$refs.basetextarearef.setCursorPosition(this.lastCursorPosition);
        });
      }catch(e) {
        this.lastCursorPosition = this.value ? this.value.length - 1 : 0;
      }
      if(this.value) {
        try {
          this.isValid = true;
          return JSON.stringify(JSON.parse(this.value), undefined, this.indentation);
        }catch (e){
          this.isValid = false;
          return this.value;
        }
      }else{
        this.isValid = true;
        return this.value;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/JSONTextareaInput.vue